import React, { useState, useEffect } from 'react';
import Register from './Register';
import TeamList from './TeamList';
import Login from './Login';
import AdComponent from './AdComponent';
import { useAuth } from './AuthContext';
import { signOut } from 'firebase/auth';
import { auth } from './firebase';
import './AppStyles.css';

function App() {
  const [activeTab, setActiveTab] = useState('register');
  const { currentUser } = useAuth();
  const [showAds, setShowAds] = useState(false);

  // ✅ CLEAN URL after Firebase redirects with ?_gl, etc.
  useEffect(() => {
    const url = new URL(window.location);
    if (url.search.length > 0) {
      const hasReloaded = sessionStorage.getItem('cleaned_url');
      if (!hasReloaded) {
        sessionStorage.setItem('cleaned_url', 'true');
        window.location.href = url.origin + url.pathname;
      }
    }
  }, []);

  // ✅ Show ads slightly delayed
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAds(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  // 🚫 If not logged in, show login + ad
  if (!currentUser) {
    return (
      <>
        <Login onLogin={() => {}} />
        {showAds && <AdComponent adSlot="1234567890" adFormat="banner" />}
      </>
    );
  }

  // ✅ Authenticated view
  return (
    <div className="app">
      <header className="app-header">
        <h1>Woodball Tournament Registration</h1>
        <nav className="app-nav">
          <button
            className={`nav-btn ${activeTab === 'register' ? 'active' : ''}`}
            onClick={() => setActiveTab('register')}
          >
            Register Team
          </button>
          <button
            className={`nav-btn ${activeTab === 'teams' ? 'active' : ''}`}
            onClick={() => setActiveTab('teams')}
          >
            View Teams
          </button>
          <button className="nav-btn" onClick={() => signOut(auth)}>
            Logout ({currentUser.email})
          </button>
        </nav>
      </header>

      {showAds && <AdComponent adSlot="2345678901" adFormat="rectangle" />}

      <main className="app-content">
        <div className="main-content-wrapper">
          {activeTab === 'register' ? <Register /> : <TeamList />}
        </div>
      </main>

      {showAds && <AdComponent adSlot="3456789012" adFormat="banner" />}

      <footer className="app-footer">
        <p>&copy; {new Date().getFullYear()} Woodball Tournament Registration</p>
      </footer>
    </div>
  );
}

export default App;
